import { render, staticRenderFns } from "./ConventionTools.vue?vue&type=template&id=736075bc&scoped=true"
import script from "./ConventionTools.vue?vue&type=script&lang=js"
export * from "./ConventionTools.vue?vue&type=script&lang=js"
import style0 from "./ConventionTools.vue?vue&type=style&index=0&id=736075bc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736075bc",
  null
  
)

export default component.exports